import { notification } from 'antd'

const logerror = (name: string, action: string, info?: any) => {
  if (!info) {
    info = 'empty'
  }
  if (typeof info === 'object') {
    info = JSON.stringify(info)
  }
  const time = new Date()

  // 打印错误，或者调用其他记录日志文件
  // eslint-disable-next-line  no-console
  console.error(name, action, info, time)
  // 提示
  notification.error({
    message: '服务异常',
    description: '您的网络异常，请检查网络连接后刷新重试',
    duration: 10,
    placement: 'bottomRight',
    className: 'notificationBox',
    btn: '刷新重试',
    onClick: () => window.location.reload(),
  })
}
export default logerror
import { notification } from 'antd'

const logerror = (name: string, action: string, info?: any) => {
  if (!info) {
    info = 'empty'
  }
  if (typeof info === 'object') {
    info = JSON.stringify(info)
  }
  const time = new Date()

  // 打印错误，或者调用其他记录日志文件
  // eslint-disable-next-line  no-console
  console.error(name, action, info, time)
  // 提示
  notification.error({
    message: '服务异常',
    description: '您的网络异常，请检查网络连接后刷新重试',
    duration: 10,
    placement: 'bottomRight',
    className: 'notificationBox',
    btn: '刷新重试',
    onClick: () => window.location.reload(),
  })
}
export default logerror
